<template>
  <div class="educspe-home">
    <header class="header-home position-relative d-flex align-items-center">
      <!-- Image de fond -->
      <div class="bg-image"></div>

      <!-- Overlay sombre -->
      <div class="overlay"></div>

      <!-- Contenu centré -->
      <div class="header-content text-center">
        <img
          src="@/assets/logotb.png"
          :alt="$t('home.hero.logoAlt')"
          class="logo-img mb-4"
        />
        <h1 class="fw-bold text-white display-4">
          {{ $t("home.hero.title") }}
        </h1>
        <h2 class="mt-5 fw-bold display-S">
          <span class="badge text-secondary rounded-pill bg-white logo-img">
            {{ $t("home.hero.badge") }}
          </span>
        </h2>
      </div>
    </header>

    <!-- SECTION HERO / SLOGAN -->
    <section class="mt-5 text-white">
      <div class="container text-center">
        <h2 class="fw-bold display-5 text-secondary">
          {{ $t("home.slogan") }}
        </h2>
      </div>
    </section>

    <!-- SECTION INTRODUCTION -->
    <section class="py-5">
      <div class="container">
        <div class="row align-items-center">
          <!-- Texte -->
          <div class="col-lg-6 mb-3">
            <h3 class="text-primary mb-3">
              {{ $t("home.intro.title") }}
            </h3>

            <p>
              {{ $t("home.intro.p1.beforeStrong") }}
              <strong>{{ $t("home.intro.p1.strong") }}</strong
              >,
              {{ $t("home.intro.p1.afterStrong") }}
            </p>

            <p>
              {{ $t("home.intro.p2") }}
            </p>

            <p>
              {{ $t("home.intro.p3.beforeStrong") }}
              <strong>{{ $t("home.intro.p3.strong") }}</strong>
            </p>
          </div>

          <!-- Image -->
          <div class="col-lg-6 text-center mb-3">
            <img
              src="@/assets/img/photo/presentation blur.png"
              :alt="$t('home.intro.imageAlt')"
              class="img-fluid rounded shadow-lg img-anime"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- SECTION PUBLIC ACCOMPAGNÉ -->
    <section class="accompagnement-section py-5 bg-light">
      <div class="container">
        <h2 class="text-center fw-bold mb-5">
          {{ $t("home.accompagnements.title") }}
        </h2>

        <div class="row g-4 d-flex justify-content-center">
          <!-- CARD 1 -->
          <div class="col-md-6 col-lg-4">
            <AccompPalliatifResume />
          </div>

          <!-- CARD 2 -->
          <div class="col-md-6 col-lg-4"><ComplexeUrgenceResume /></div>

          <!-- CARD 3 -->
          <div class="col-md-6 col-lg-4"><SoinsResume /></div>

          <!-- CARD 4 -->
          <div class="col-md-6 col-lg-4"><PersAgeResume /></div>

          <!-- CARD 5 -->
          <div class="col-md-6 col-lg-4"><AutonomieHandicapResume /></div>

          <!-- CARD 6 -->
          <div class="col-md-6 col-lg-4"><EnfantsEtAdolescentsResume /></div>

          <!-- CARD 7 -->
          <div class="col-md-6 col-lg-4"><InstitutionsResume /></div>

          <!-- CARD 8 -->
          <div class="col-md-6 col-lg-4">
            <VoyagesResume />
          </div>

          <!-- CARD 9 -->
          <div class="col-md-6 col-lg-4">
            <MiseAuLitResume />
          </div>
        </div>
      </div>
    </section>

    <!-- Equipe -->
    <section class="section-equipe py-5">
      <div class="container">
        <div class="row justify-content-center text-center mb-5">
          <div class="col-lg-8">
            <h2 class="fw-bold mb-3">
              {{ $t("home.teamSection.title") }}
            </h2>
            <p class="text-muted lead">
              {{ $t("home.teamSection.lead") }}
            </p>
          </div>
        </div>

        <div class="mb-5">
          <div class="row align-items-center flex-column flex-md-row">
            <!-- Icône -->
            <div class="col-md-2 d-flex justify-content-center mb-3 mb-md-0">
              <div
                class="icon-circle d-flex justify-content-center align-items-center bg-primary text-white shadow-lg"
              >
                <i class="fa-solid fa-car"></i>
              </div>
            </div>

            <!-- Texte -->
            <div class="col-md-10">
              <h4 class="fw-bold">
                {{ $t("home.teamSection.vehicle.title") }}
              </h4>
              <p class="mb-0">
                {{ $t("home.teamSection.vehicle.text") }}
              </p>
            </div>
          </div>
        </div>

        <!-- CARD -->
        <div class="row justify-content-center">
          <div class="col-md-10 col-lg-8">
            <div class="card equipe-card shadow-sm border-0">
              <div class="row g-0 align-items-center">
                <!-- Image -->
                <div class="col-md-5">
                  <div class="equipe-img-wrapper">
                    <img
                      src="@/assets/img/photo/1/22.40.08.jpeg"
                      :alt="$t('home.teamSection.card.imageAlt')"
                      class="img-fluid equipe-img"
                    />
                  </div>
                </div>

                <!-- Content -->
                <div class="col-md-7">
                  <div class="card-body">
                    <h4 class="fw-bold">
                      {{ $t("home.teamSection.card.title") }}
                    </h4>
                    <p class="text-muted">
                      {{ $t("home.teamSection.card.text") }}
                    </p>

                    <a
                      href="/qui-sommes-nous"
                      class="btn btn-primary mt-2 px-4"
                    >
                      {{ $t("home.teamSection.card.button") }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CALL TO ACTION -->
    <Cta />
  </div>
</template>

<script>
import { useHead } from "@vueuse/head";
import { useI18n } from "vue-i18n";

import Cta from "@/components/Cta.vue";
import AccompPalliatifResume from "@/components/ResumeService/AccompPalliatifResume.vue";
import ComplexeUrgenceResume from "@/components/ResumeService/ComplexeUrgenceResume.vue";
import SoinsResume from "@/components/ResumeService/SoinsResume.vue";
import PersAgeResume from "@/components/ResumeService/PersAgeResume.vue";
import AutonomieHandicapResume from "@/components/ResumeService/AutonomieHandicapResume.vue";
import EnfantsEtAdolescentsResume from "@/components/ResumeService/EnfantsEtAdolescentsResume.vue";
import InstitutionsResume from "@/components/ResumeService/InstitutionsResume.vue";
import VoyagesResume from "@/components/ResumeService/VoyagesResume.vue";
import MiseAuLitResume from "@/components/ResumeService/MiseAuLitResume.vue";

export default {
  name: "Home",
  components: {
    Cta,
    AccompPalliatifResume,
    ComplexeUrgenceResume,
    SoinsResume,
    PersAgeResume,
    AutonomieHandicapResume,
    EnfantsEtAdolescentsResume,
    InstitutionsResume,
    VoyagesResume,
    MiseAuLitResume,
  },
  setup() {
    const { t } = useI18n();

    useHead(() => ({
      title: t("home.meta-data.title"),
      meta: [
        {
          name: "description",
          content: t("home.meta-data.desc"),
        },
      ],
    }));
  },
};
</script>

<style scoped>
.header-home {
  height: calc(100dvh - 100.641px);
  min-height: calc(100svh - 100.641px);
  position: relative;
  overflow: hidden;
}

/* Image de fond */
.header-home .bg-image {
  background-image: url("@/assets/img/photo/hands-4344711.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
}

/* Filtre sombre */
.header-home .overlay {
  background: rgba(56, 71, 66, 0.788); /* intensité du filtre */
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
}

/* Contenu centré */
.header-home .header-content {
  position: relative;
  z-index: 3;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

/* Animation battement de cœur */
@keyframes heartbeat {
  0% {
    transform: scale(1);
  }
  10% {
    transform: scale(1.08);
  }
  20% {
    transform: scale(0.98);
  }
  30% {
    transform: scale(1.06);
  }
  40% {
    transform: scale(1);
  }
  100% {
    transform: scale(1);
  }
}

/* Application de l’animation au logo */
.logo-img {
  width: 50%;
  height: auto;
  animation: heartbeat 2s ease-in-out infinite;
  /* Optionnel : rendre l'effet plus doux */
  transform-origin: center;
}

@media (max-width: 768px) {
  .logo-img {
    width: 60%;
  }
}

@media (max-width: 480px) {
  .logo-img {
    width: 70%;
  }
}

.btn-primary {
  background-color: #4b7268;
  border: none;
}

.btn-primary:hover {
  background-color: #39564c;
}

.section-equipe {
  background: #f8faf9;
}

.equipe-card {
  border-radius: 16px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.equipe-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);
}

.equipe-img-wrapper {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.equipe-img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.equipe-card:hover .equipe-img {
  transform: scale(1.1);
}

.btn-primary {
  background-color: #4b7268;
  border: none;
}

.btn-primary:hover {
  background-color: #39564c;
}

.icon-circle {
  width: 90px;
  height: 90px;
  border-radius: 50%; /* bleu bootstrap */
  font-size: 40px;
}
</style>
